export enum BusGrade {
  Excellent = '1', // 우등
  Normal = '2', // 일반
  NightExcellent = '3', // 심야 우등
  NightNormal = '4', // 심야 일반
  Premium = '7', // 프리미엄
  NightPremium = '8', // 심야 프리미엄
}
export enum BusTicketType {
  NORMAL = '1', // 성인
  ELEMENTARY = '2', // 초등학생
  COLLEGE = '8', // 대학생
  MIDDLE_HIGH = '9', // 중고등학생
}

export const defBusTicketType = {
  NORMAL: '성인',
  ELEMENTARY: '초등학생',
  MIDDLE_HIGH: '중고등학생',
  COLLEGE: '대학생',
}

export const defBusGrade = {
  Excellent: '우등',
  Normal: '일반',
  NightExcellent: '심야 우등',
  NightNormal: '심야 일반',
  Premium: '프리미엄',
  NightPremium: '심야 프리미엄',
}

export const defBusUnavailableReason = {
  SoldOut: '해당 좌석 매진',
  Stop: '예약 마감',
  PriceChanged: '가격 변경',
  Outdated: '상품 정보 변경',
  Uncategorized: '예약 불가',
  OutOfStock: '좌석 부족',
}

export const NolMoneyClickNames = {
  Login: '로그인하기',
  RegisterAccount: '충전 계좌 등록하기',
  GoToAccountRegister: '충전하려면 계좌를 등록해 주세요',
}
